
import styled from 'styled-components'

import COLORS from 'constants/colors'
import FONTS from 'constants/fonts'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


import BGRIMAGE from 'assets/images/backgrounds/bgr-about-quote.webp'

export const OurStoryWrap = styled.div`
  background: ${COLORS.LIGHTYELLOW};
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
  `}
`

export const SubpageSection = styled.div`
  background: ${COLORS.LIGHTYELLOW} url(${BGRIMAGE}) no-repeat center center;
  background-size: contain;
  max-width: 800px;
  margin: auto;
  text-align: center;
`

export const QuoteText = styled.p`
  color: ${COLORS.BLUE};
  font-family: ${FONTS.FAMILYSECONDARY};
  font-weight: ${FONTS.WEIGHTREGULAR};
  font-size: ${FONTS.QUOTEMOBILE};
  position: relative;
  padding: 0 30px;
  ${MEDIA.medium`
    font-size:  ${FONTS.QUOTE};
  `}
  &:before {
    content: open-quote;
    font-family: Georgia, sans-serif;
    font-size: 100px;
    position: absolute;
    top: 35px;
    left: 0;
    line-height: 0;
  }
  &:after {
    content: close-quote;
    font-family: Georgia, sans-serif;
    font-size: 100px;
    position: absolute;
    bottom: -15px;
    right: 0;
    line-height: 0;
  }
`

export const TeamMemberName = styled.h3`
  font-size: ${FONTS.FONTSECTIONTITLEMOBILE};
  font-family: ${FONTS.FAMILYSECONDARY};
  margin: 20px 0 0 0;
  ${MEDIA.medium`
    font-size: ${FONTS.FONTSECTIONTITLE};
  `}
`

export const TeamMemberTitle = styled.span`
  font-size: ${FONTS.PARAGRAPHMOBILE};
  font-weight: ${FONTS.WEIGHTLIGHT};
  display: block;
  margin: 0;
  ${MEDIA.medium`
    font-size: ${FONTS.PARAGRAPH};
  `}
`

export const Signature = styled.div`
  image {
    width: 100%;
    height: auteo;
    max-width: 320px;
  }
`
